<template>
    <div class="row">
        <div class="form-group col-lg-6">
            <label class="font-weight-bold">{{ $t('otherFields.other1') }}</label>
            <textarea class="form-control" v-model="otherFields.other1" readonly/>
        </div>
        <div class="form-group col-lg-6">
            <label class="font-weight-bold">{{ $t('otherFields.other2') }}</label>
            <textarea class="form-control" v-model="otherFields.other2" readonly/>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            otherFields: {
                type: Object
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
